import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import {
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import DataTables from 'material-ui-datatables';

import { sortStrings, getOrderDirection, contains } from '../../utils/helper';
import { hasPermission } from '../../utils/authenticated';
import styles from './styles';
import commonStyles from '../styles';

const getTableColumns = (primaryContactId, editable, onEdit, onRemove, onSetPrimary) => {
  return _.flatten([{
    key: 'primaryContactId',
    label: '',
    render: (a, contact) => contact.id === primaryContactId ?
      <FontIcon className="material-icons" style={styles.primaryIcon}>stars</FontIcon> : null,
    style: styles.primaryCol,
  }, {
    key: 'name',
    label: 'Name',
    render: (name) => name,
    sortable: true,
    style: styles.nameCol,
  }, {
    key: 'telephone',
    label: 'Telephone',
    render: (telephone) => telephone,
    style: styles.telephoneCol,
  }, {
    key: 'email',
    label: 'Email',
    render: (email) => email,
    style: styles.telephoneCol,
  }, {
    key: 'action',
    label: '',
    render: (a, contact) => {
      return (<span>
          { onEdit ? <IconButton tooltip="Edit" tooltipPosition="bottom-center" onClick={(evt) => {
            evt.stopPropagation();
            onEdit(contact);
          }}>
            <FontIcon className="material-icons" style={styles.icon}>edit</FontIcon>
          </IconButton> : null }
        { onRemove ? <IconButton tooltip="Remove" tooltipPosition="bottom-center" onClick={(evt) => {
          evt.stopPropagation();
          onRemove(contact);
        }}>
          <FontIcon className="material-icons" style={styles.icon}>delete</FontIcon>
        </IconButton> : null }
        {/*<IconButton tooltip="Set as Primary" tooltipPosition="bottom-center" onClick={(evt) => {*/}
          {/*evt.stopPropagation();*/}
          {/*onSetPrimary(contact);*/}
        {/*}}>*/}
           {/*<FontIcon className="material-icons" style={styles.icon}>stars</FontIcon>*/}
        {/*</IconButton>*/}
          </span>);
    },
    alignRight: true,
    style: styles.actionCol,
  },
  ]);
};

const getSorter = (sorter = (a, b) => 0, order = 'asc') => {
  return (a, b) => {
    let result = sorter(a, b);

    if (result === 0) {
      result = sortStrings(a.name, b.name);

      if (result === 0) {
        result = sortStrings(a.id, b.id);
      }
    }

    return result * getOrderDirection(order);
  };
};

const getContactFilter = (filter) => {
  return (contact) => {
    if (filter) {
      if (contains(contact.name, filter)) {
        return true;
      }
      if (contains(contact.email, filter)) {
        return true;
      }

      return false;
    }

    return true;
  };
};

class ContactsTable extends Component {
  static propTypes = {
    contacts: PropTypes.array,
    primaryContactId: PropTypes.string,
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
    onSetPrimary: PropTypes.func,
  };

  state = {
    selectedRows: [],
    page: 1,
    limit: 5,
    sortBy: getSorter(),
    order: 'asc',
    data: [],
  };

  componentWillMount() {
    this.setState({
      editable: hasPermission(['Administrator', 'JobCreator']),
      data: this.props.contacts.sort(this.state.sortBy),
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.contacts.sort(this.state.sortBy),
    });
  }

  handleFilterValueChange = (filter) => {
    const { contacts } = this.props;
    const { page, limit, sortBy } = this.state;

    const data = contacts.filter(getContactFilter(filter ? filter.trim().toLowerCase() : '')).sort(sortBy);
    this.setState({
      page: Math.min(page, Math.floor(data.length / limit) + 1),
      data,
    });
  };

  handleSortOrderChange = (key, order) => {
    let sortBy = getSorter();
    switch (key) {
      case 'name':
        sortBy = getSorter((a, b) => sortStrings(a.name, b.name), order);
        break;
      default:
        break;
    }

    this.setState({
      data: this.state.data.sort(sortBy),
      sortBy,
    });
  };

  handlePreviousPageClick = () => {
    this.setState({
      page: Math.max(1, this.state.page - 1),
    });
  };

  handleNextPageClick = () => {
    const { data, page, limit } = this.state;

    this.setState({
      page: Math.min(Math.ceil(data.length / limit), page + 1),
    });
  };

  handleRowSizeChange = (a, limit) => {
    this.setState({
      limit,
      page: 1,
    });
  };

  renderNoData() {
    return (<TableRow key="nodata">
      <TableRowColumn colSpan={5} style={commonStyles.noDataRow}>
        <FontIcon className="material-icons" style={styles.noData}>person</FontIcon>
        <div>No contacts are available</div>
      </TableRowColumn>
    </TableRow>);
  }

  render() {
    const { primaryContactId, onEdit, onRemove, onSetPrimary } = this.props;
    const { editable, page, limit, data } = this.state;

    return (
      <DataTables
        height={'auto'}
        showRowHover
        columns={getTableColumns(primaryContactId, editable, onEdit, onRemove, onSetPrimary)}
        data={data.slice((page - 1) * limit, page * limit)}
        onFilterValueChange={this.handleFilterValueChange}
        onSortOrderChange={this.handleSortOrderChange}
        onPreviousPageClick={this.handlePreviousPageClick}
        onNextPageClick={this.handleNextPageClick}
        onRowSizeChange={this.handleRowSizeChange}
        page={page}
        rowSize={limit}
        rowSizeList={[5, 10, 15, 20]}
        count={data.length}
        filterHintText="Filter"
        headerToolbarMode="filter"
        showHeaderToolbar
      />);
  }
}

export default ContactsTable;



// WEBPACK FOOTER //
// ./src/components/ContactsTable/index.js